export default "__VITE_ASSET__ea816420__"